module.exports = __webpack_public_path__ + "img/inspiration-4.c7e1991.jpg";